import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";
import Head from "next/head";
import withPreserveAppQueryParams from "./withPreserveAppQueryParams";

function Page() {
  return (
    <>
      <Head>
        <title>Price Promise</title>
        <meta
          name="description"
          content="Have a question? We're here to help with all your queries, from delivery and returns to orders and your online account and your My John Lewis membership."
        />
      </Head>
      <ESIPage />
    </>
  );
}

export default withPreserveAppQueryParams(Page, ["/customer-services/prices-and-payment/price-promise/request"]);
